<template>
  <span>
    <v-dialog v-model="dialog" width="50%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text color="light-blue" v-bind="attrs" v-on="on">
          <v-icon>mdi-cash-multiple</v-icon> {{ prefered_currency }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title
          class="text-h5 light-blue font-weight-regular darken-4 white--text"
        >
          {{ $t("Selectyourcurrency") }}
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" dark x-small fab @click="dialog = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-9">
          <v-item-group mandatory v-model="prefered_currency">
            <v-row>
              <v-col v-for="n in currencies" :key="n.code" cols="12" md="3">
                <v-item v-slot="{ active }" :value="n.code">
                  <v-card
                    :color="
                      active ? 'light-blue white--text' : 'grey lighten-3'
                    "
                    @click="updatePreferedCurrency(n.code)"
                    class="text-center"
                    height="100%"
                  >
                    <v-icon class="right-top" v-if="active" dark>
                      mdi-check-circle
                    </v-icon>
                    <div class="subtitle-1 text-center pa-5 pb-0">
                      {{ $t(n.code) }}
                    </div>
                    <p class="caption pl-5 pr-5">{{ n.name }}</p>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
        </v-card-text>
      </v-card>
    </v-dialog>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </span>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import Currencies from "@/assets/currencies.json";
import AuthService from "@/services/AuthService";
export default {
  name: "CurrencySelectorComponent",
  components: { WaitDialogComponent },
  data() {
    return {
      dialog: false,
      waitDialog: false,
      prefered_currency: this.$store.state.user.prefered_currency,
      currencies: Currencies
    };
  },
  methods: {
    updatePreferedCurrency: function(val) {
      this.dialog = false;
      this.$store.dispatch("setUser", { prefered_currency: val });
      if (this.$store.getters.isLoggedIn) {
        this.waitDialog = true;
        AuthService.updatePreferedCurrency({
          prefered_currency: val
        })
          .then(result => {
            this.message = result.data.msg;
            this.$store.dispatch("setUser", result.data.user);
            setTimeout(() => (this.waitDialog = false), 200);
            this.$router.go();
          })
          .catch(err => {
            this.error = err;
            this.$store.dispatch("logout");
            this.$router.push({
              name: "Login",
              params: { redirectUrl: "home" }
            });
            setTimeout(() => (this.waitDialog = false), 200);
          });
      } else {
        this.$router.go();
      }
    }
  }
};
</script>

<style></style>
